import { Component, OnInit, Input  } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() nombres: string;
  @Input() apellidos: string;


  background="#23273B"
  avatar: any = "assets/img/logo.png";
  constructor() { }

  ngOnInit(): void {

   
  }

}
